// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-receipt-commons-SocialMediaLink-__SocialMediaLink___1Oh07","header":"app-components-receipt-commons-SocialMediaLink-__SocialMediaLink___3kV4s","link-icon-wrapper":"app-components-receipt-commons-SocialMediaLink-__SocialMediaLink___3oX-R","instagram-icon-wrapper":"app-components-receipt-commons-SocialMediaLink-__SocialMediaLink___Hei3p","facebook-icon-wrapper":"app-components-receipt-commons-SocialMediaLink-__SocialMediaLink___3KsuO","twitter-icon-wrapper":"app-components-receipt-commons-SocialMediaLink-__SocialMediaLink___2Wtgq"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/commons/SocialMediaLink/SocialMediaLink.css
// module id = 2231
// module chunks = 0